import { useEffect } from 'react';

import { Navigate, Outlet, useLocation } from 'react-router';

import { useAppDispatch } from '@/hooks/redux-hooks';
import {
  useGxTokenFromStorage,
  setPathnameToStorage,
  useTripTokenFromStorage
} from '@/services/storage';
import { loginTrip } from '@/slices/authSlice';
import { getDataHubs } from '@/slices/dataHubSlice';
import { getMarketsList } from '@/slices/marketsListSlice';
import { getUserConfig } from '@/slices/userConfigSlice';

const ProtectedLayout = () => {
  const gxToken = useGxTokenFromStorage();
  const dispatch = useAppDispatch();
  const tripToken = useTripTokenFromStorage();
  const location = useLocation();

  useEffect(() => {
    if (gxToken) {
      dispatch(loginTrip(gxToken));
    }
  }, [dispatch, gxToken]);

  useEffect(() => {
    if (tripToken) {
      dispatch(getMarketsList());
      dispatch(getUserConfig());
      dispatch(getDataHubs());
    }
  }, [dispatch, tripToken]);

  if (!gxToken) {
    setPathnameToStorage(location.pathname);

    return (
      <Navigate
        replace
        to='/login'
      />
    );
  }
  return <Outlet />;
};

export default ProtectedLayout;
